import React from 'react';
import Icon from '../../../components/AppIcon';
import { formatScheduledTimeDisplay } from '../appointmentTiming';

const ServiceTimeline = ({
  currentStatus,
  statusHistory,
  scheduledDate,
  scheduledTimeStart,
  actualArrivalTime,
  completionTime,
}) => {
  const statuses = [
    { id: 'planned', label: 'Planifiée', icon: 'Calendar' },
    { id: 'en_route', label: 'En route', icon: 'Navigation' },
    { id: 'on_site', label: 'Sur place', icon: 'MapPin' },
    { id: 'completed', label: 'Terminée', icon: 'CheckCircle' },
  ];

  const normalizedStatus = `${currentStatus || ''}`.toLowerCase().trim();
  const currentIndex = statuses.findIndex((s) => s.id === normalizedStatus);

  const formatTime = (timestamp) => {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    if (Number.isNaN(date.getTime())) return '';
    return date.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
  };

  const getStatusTime = (statusId) => {
    if (statusId === 'planned') {
      return formatScheduledTimeDisplay(scheduledTimeStart);
    }

    const history = statusHistory?.find((h) => h?.status === statusId);
    if (history?.timestamp) {
      return formatTime(history.timestamp);
    }

    if (statusId === 'on_site' && actualArrivalTime) {
      return formatTime(actualArrivalTime);
    }

    if (statusId === 'completed' && completionTime) {
      return formatTime(completionTime);
    }

    return '';
  };

  return (
    <div className="bg-card rounded-lg p-4 sm:p-6 shadow-sm border border-border">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-base sm:text-lg font-semibold text-foreground">
          Suivi de l&apos;intervention
        </h2>
      </div>

      <div className="relative">
        <div className="absolute top-6 left-0 right-0 h-0.5 bg-muted">
          <div
            className="h-full bg-primary transition-all duration-500"
            style={{
              width:
                currentIndex < 0
                  ? '0%'
                  : `${(currentIndex / (statuses.length - 1)) * 100}%`,
            }}
          />
        </div>

        <div className="relative flex justify-between">
          {statuses.map((status, index) => {
            const isCompleted = currentIndex >= 0 && index <= currentIndex;
            const isCurrent = index === currentIndex;
            const statusTime = getStatusTime(status.id);

            return (
              <div key={status.id} className="flex flex-col items-center" style={{ width: '25%' }}>
                <div
                  className={`w-10 h-10 sm:w-12 sm:h-12 rounded-full flex items-center justify-center mb-2 sm:mb-3 transition-all duration-300 ${
                    isCompleted
                      ? 'bg-primary text-primary-foreground shadow-md'
                      : 'bg-muted text-muted-foreground'
                  } ${isCurrent ? 'ring-4 ring-primary/20 scale-110' : ''}`}
                >
                  <Icon
                    name={status.icon}
                    size={20}
                    color={isCompleted ? '#FFFFFF' : 'currentColor'}
                  />
                </div>
                <span
                  className={`text-xs sm:text-sm font-medium mb-1 text-center ${
                    isCompleted ? 'text-foreground' : 'text-muted-foreground'
                  }`}
                >
                  {status.label}
                </span>
                {statusTime && (
                  <span className="text-[11px] sm:text-xs text-muted-foreground">{statusTime}</span>
                )}
              </div>
            );
          })}
        </div>
      </div>

      {currentStatus === 'en_route' && (
        <div className="mt-6 p-4 bg-primary/10 rounded-lg flex items-start gap-3">
          <Icon name="Info" size={20} className="text-primary mt-0.5 flex-shrink-0" />
          <div>
            <p className="text-sm font-medium text-foreground">Technicien en route</p>
            <p className="text-xs text-muted-foreground mt-1">
              Votre technicien est en chemin. Vous recevrez une notification à son arrivée.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ServiceTimeline;
